module.exports = __webpack_public_path__ + "img/BTN_recent_pot.a35b0865.png";